import DashboardLayout from './dashboard-layout';

export default DashboardLayout;
